/**
 * FullScreenLoader component displays a full-screen circular loading spinner.
 * Used to indicate that the application is loading or processing a request.
 * 
 * @component
 * @returns {JSX.Element} A full-screen loader with animated circular spinner
 * 
 * @example
 * ```tsx
 * {isLoading ? <FullScreenLoader /> : <AppContent />}
 * ```
 */
export default function FullScreenLoader() {
    return (
        <div className="loader-wrapper">
            <div className="loader">
                <svg className='circular' viewBox='25 25 50 50'>
                    <circle className='path' cx='50' cy='50' r='20' fill='none' strokeWidth='5' strokeMiterlimit='10' ></circle>
                </svg>
            </div>
        </div>
    )
};